import { SyntheticEvent } from "react";
import { COAST_CATEGORIES } from "../../../shared/constants";

interface CoastFeedCategorySelectorProps {
    handleChange(e: SyntheticEvent): void;
    displayHostCategories: boolean;
    selectedCategory?: string;
}

const getOptionsList = (tags: typeof COAST_CATEGORIES.regular) =>
    tags.map(tag => (
        <option key={tag.name} label={tag.displayName} value={tag.name}>
            {tag.displayName}
        </option>
    ));

export const CoastFeedCategorySelector = ({
    displayHostCategories,
    selectedCategory,
    handleChange,
}: CoastFeedCategorySelectorProps) => (
    <div className="coast-feed-navigation-filter">
        {/* Using onBlur here makes react mad */}
        {/* eslint-disable-next-line jsx-a11y/no-onchange */}
        <select name="category" onChange={handleChange} value={selectedCategory}>
            <option key="all" label="All Categories" value="all-categories">
                All Categories
            </option>

            {getOptionsList(COAST_CATEGORIES.regular)}

            {displayHostCategories ? (
                <optgroup label="By Host">{getOptionsList(COAST_CATEGORIES.hosts)}</optgroup>
            ) : null}
        </select>
    </div>
);
